import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function MembersView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "ID Number",
      children: prodd?.usrNationalId ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: prodd?.email ?? "N/A",
    },
    {
      key: "5",
      label: "County",
      children: prodd?.countyName ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: prodd?.subCountyName ?? "N/A",
    },
    {
      key: "33",
      label: "Locaton",
      children: prodd?.locationName ?? "N/A",
    },
    {
      key: "34",
      label: "Sublocation",
      children: prodd?.subLocationName ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constituency ?? "N/A",
    },
    {
      key: "55",
      label: "Ward",
      children: prodd?.ward ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: prodd?.phoneNumber ?? "N/A",
    },
    {
      key: "6",
      label: "Created Date",
      children: (
        <div>
          {prodd?.createdDate
            ? moment(prodd?.createdDate)?.format("DD-MM-YYYY HH:mm:ss")
            : "--"}
        </div>
      ),
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Land Size",
      children: prodd?.landSize ?? "N/A",
    },
    {
      key: "5",
      label: "Water Source",
      children: prodd?.altWaterSource ?? "N/A",
    },
    {
      key: "2",
      label: "Major Crops",
      children: prodd?.majorCrop ?? "N/A",
    },
  ];
  const items3 = [
    {
      key: "1",
      label: "Name",
      children: prodd?.fullNames ?? "N/A",
    },

    {
      key: "2",
      label: "Phone",
      children: prodd?.phoneNumber ?? "N/A",
    },
  ];
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Member Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Member Details"
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title="Farm Details"
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          title="Contact Person"
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default MembersView;
